





































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import store from "@/services/store";

@Component
export default class AddProgramButton extends Vue {
    @Prop({ required: true }) currentYear!: number;
    @Prop({ required: true }) selectedRegion!: { code: string; name: string } | null;
    @Prop({ default: () => [] }) existingProgramIds!: number[];
    @Prop({ default: () => [] }) readonly regionsList!: Array<{ code: string; name: string }>;
    @Prop({ default: false }) hasEditAccess!: boolean;

    public modalVisible = false;
    public programArr: any[] = [];
    public selectedProgram: any = null;

    private padLeadingZeros(num: string, size: number): string {
        return num.padStart(size, '0');
    }

    private async openModal() {
        if (!this.hasEditAccess) {
            this.makeToast('warning', 'Доступ запрещен', 'У вас нет прав для добавления программ');
            return;
        }

        this.selectedProgram = null;
        await this.loadPrograms();
        this.modalVisible = true;
    }

    private async loadPrograms() {
        let katoCodes: string[] = [];

        if (this.selectedRegion && this.selectedRegion.code) {
            katoCodes = [this.padLeadingZeros(this.selectedRegion.code, 9)];
        } else if (this.regionsList.length > 0) {
            katoCodes = this.regionsList.map(r => this.padLeadingZeros(r.code, 9));
        } else {
            this.programArr = [];
            return;
        }

        const query = new URLSearchParams({
            year: String(this.currentYear),
            codeKato: katoCodes.join(','),
        });

        try {
            const response = await fetch(`/api/program-passport/available-programs?${query}`);
            const data = await response.json();
            this.programArr = data
                .filter((el: any) => !this.existingProgramIds.includes(el.id))
                .map((el: any) => this.setNameLangs(el, ''));
        } catch (err) {
            this.makeToast('danger', 'Ошибка загрузки программ', err.toString());
        }
    }

    private setNameLangs(obj: any, codeName: string) {
        let txt = obj.name_ru || obj.name || '';
        if (codeName && obj[codeName]) {
            txt = `${obj[codeName]} - ${txt}`;
        }
        const el = Object.assign({}, obj);
        el.name = txt;
        return el;
    }

    private makeToast(variant: string, title: string, tostbody: string) {
        this.$bvToast.toast(tostbody, {
            title,
            autoHideDelay: 5000,
            variant,
            appendToast: true
        });
    }

    private async saveProgram() {
        if (!this.hasEditAccess) {
            this.makeToast('warning', 'Доступ запрещен', 'У вас нет прав для добавления программ');
            return;
        }

        if (!this.selectedProgram || !this.selectedProgram.id) return;

        const result = await fetch(`/api/program-passport/add/${this.selectedProgram.id}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
        });

        if (result.ok) {
            this.$bvToast.toast('Программа успешно добавлена', { variant: 'success', title: 'Успех' });
            this.modalVisible = false;
            this.$emit('programAdded');
            this.$emit('refreshFilter');
        } else {
            this.$bvToast.toast('Ошибка при сохранении программы', { variant: 'danger', title: 'Ошибка' });
        }
    }

    private selectProgram(program: any) {
        this.selectedProgram = program;
    }
}
